const faqItems = [
  {
    q: '番茄漫画是免费的吗？',
    a: '是的！番茄漫画上的所有漫画内容完全免费阅读，包括热门连载、经典完结、韩漫日漫国漫全部免费畅读。我们致力于为广大漫友提供优质的免费漫画阅读体验，无需付费订阅。',
  },
  {
    q: '什么是下拉式竖屏阅读？',
    a: '下拉式竖屏阅读是一种专为手机设计的漫画阅读方式。不同于传统的左右翻页，你只需要像刷短视频一样向下滑动，漫画内容就会连续流畅地展示。这种方式特别适合竖屏漫画和条漫，让阅读体验更加沉浸自然。',
  },
  {
    q: '支持离线缓存吗？如何使用？',
    a: '完全支持！在番茄漫画 APP 中，你可以在漫画详情页点击"缓存"按钮，选择要缓存的章节范围。缓存完成后，即使没有网络也可以随时随地阅读。我们采用智能缓存技术，占用空间小，加载速度快。',
  },
  {
    q: '番茄漫画有哪些类型的漫画？',
    a: '我们覆盖韩漫、日漫、国漫三大品类，包含热血格斗、恋爱甜宠、悬疑推理、穿越重生、系统升级、玄幻修仙、搞笑日常等十几种类型。无论你喜欢什么风格的漫画，都能在这里找到适合自己的作品。',
  },
  {
    q: '漫画更新频率怎么样？',
    a: '番茄漫画每天更新超过1000话内容，热门连载基本保持同步更新。你可以在"最近更新"模块中查看最新的更新动态，不错过任何一部追更漫画的最新章节。',
  },
  {
    q: '如何联系番茄漫画团队？',
    a: '你可以通过"联系我们"模块中的邮箱 contact@fanqiecomic.com 与我们取得联系。无论是漫画推荐、内容反馈、商务合作还是版权问题，番茄漫画团队都会尽快回复你的来信。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">常见问题</h2>
          <p className="text-foreground-500 text-sm mt-2">你可能想了解的一些事情</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <div className="p-5">
                <h3 className="text-sm font-semibold text-foreground-900 flex items-start gap-3">
                  <span className="w-5 h-5 rounded-full bg-primary-100/70 text-primary-700 flex items-center justify-center text-[10px] font-bold shrink-0 mt-0.5">
                    Q
                  </span>
                  {item.q}
                </h3>
                <div className="mt-3 pl-8">
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}